import { createSlice } from "@reduxjs/toolkit";

const initialPWSSlice = {
        dropdownSource: {
                movementtype: [],
                tanks: [],
                lockDatesUntil: '1900-01-01'
        },
        saveStatus: {
                isSaving: false,
                success: false,
                error: '',
                controlno: {
                        is_no_prev_entry: -1,
                        source_no_prev_entry: -1,
                        receiving_no_prev_entry: -1,
                        no_ops_day: -1,
                        prev_date: ''
                }
        },
        pwsDetails: {
                isLoading: false,
                success: false,
                error: '',
                details: {}
        }
};

export const PWSSlice = createSlice({
        name: "pws",
        initialState: initialPWSSlice,
        reducers: {
                SetDropDownSource: (state, action) => {
                        let mt = [];
                        let tnks = [];
                        action.payload.movementtype.forEach((m) => { mt.push(m.movement_type_name) });
                        action.payload.tanks.forEach((t) => { tnks.push(t.tank_no) });
                        state.dropdownSource = {
                                movementtype: action.payload.movementtype,
                                tanks: action.payload.tanks,
                                lockDatesUntil: action.payload.lockDatesUntil
                        }
                },
                StartSavingPWS: (state, action) => {
                        state.saveStatus = {
                                isSaving: true, success: false, controlno: null, error: ''
                        }
                },
                SetSaveStatus: (state, action) => {
                        state.saveStatus = {
                                isSaving: false, success: action.payload.success, controlno: action.payload.controlno, error: action.payload.error
                        }
                },
                ResetSaveStatus: (state, action) => {
                        state.saveStatus = initialPWSSlice.saveStatus;
                },
                StartLoadingPWSDetails: (state, action) => {
                        state.pwsDetails = {
                                isLoading: true,
                                success: false,
                                error: '',
                                details: {}
                        }
                },
                SetPWSDetails: (state, action) => {
                        state.pwsDetails = {
                                isLoading: false,
                                success: action.payload.success,
                                error: action.payload.error,
                                details: action.payload.details
                        }
                }

        }
});